export default __webpack_public_path__ + "static/media/padel-gold-thumbnail.fc61d0b3.png";